import Vue from 'vue';
import Router from 'vue-router';
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';
import store from './store';
import Home from './views/Home.vue';
import ServerDetails from './views/ServerDetails.vue';
import OidcCallback from './components/OidcCallback.vue';
import Servers from './views/ServerList.vue';
import PodDashboard from './views/Pod/Dashboard.vue';
import PodServerDetails from './views/Pod/ServerDetails.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/signin-oidc',
      name: 'oidc-callback',
      component: OidcCallback,
      meta: {
        isVuexOidcCallback: true,
        isPublic: true,
      },
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/servers/:server',
      name: 'server-details',
      component: ServerDetails,
    },
    {
      path: '/server_list',
      name: 'servers',
      component: Servers,
    },
    {
      path: '/customers/pod',
      name: 'pod',
      component: PodDashboard,
      meta: {
        customer: 'pod',
        theme: 'theme-pod',
        title: 'LiveStore POD Service Health'
      }
    },
    {
      path: '/customers/pod/servers/:server',
      name: 'pod-server-details',
      component: PodServerDetails,
      meta: {
        customer: 'pod',
        theme: 'theme-pod',
        title: 'LiveStore POD Store Health'
      }
    },
  ],
});

router.beforeEach((to, _, next) => {
  if (to.matched.length === 0) {
    return next();
  }
  document.title = to.matched[0].meta.title || 'Landscape Reporting';
  return next();
});

// require auth for pages that aren't flagged as public
router.beforeEach(vuexOidcCreateRouterMiddleware(store));

export default router;
